import {
  HeaderFlexible,
  GlobalNavigation,
  NavigationList,
  NavigationDropdownItem,
  NavigationListItem,
  MainBar
} from "@sainsburys-tech/fable";
import { useNavigate } from "react-router-dom";
import SmartPrint from "../../assets/icons/image.png";
import Styles from "./HeaderFile.module.css";
import UserAvatar from "../common/Avatar/UserAvatar";
import { getLogisticsRole } from "../../utils/authToken";
import { USER_ROLE } from "../../constants/roles";

const Headerfile = () => {
  const navigate = useNavigate();

  let isLoggedIn: any;
  const loggedUserRole = getLogisticsRole();

  const jsonString: string | null = localStorage.getItem("accessToken");

  if (jsonString) {
    jsonString !== null ? (isLoggedIn = true) : (isLoggedIn = false);
  } else {
    console.error("No data found in session storage for the given key.");
  }

  return (
    <>
      <HeaderFlexible>
        <GlobalNavigation>
          <NavigationList></NavigationList>
          <GlobalNavigation.Section>
            {isLoggedIn === true ? (
              <NavigationList>
                <NavigationListItem>
                  <UserAvatar />
                </NavigationListItem>
              </NavigationList>
            ) : (
              <></>
            )}
          </GlobalNavigation.Section>
        </GlobalNavigation>
        <MainBar
          style={{
            borderBottom: "1px solid #e0e0e0",
            borderTop: "1px solid #e0e0e0"
          }}
        >
          <MainBar.Logo>
            <img
              src={SmartPrint}
              alt="Product Card placeholder"
              className={Styles.logo}
            />
          </MainBar.Logo>
          {isLoggedIn === true ? (
            loggedUserRole === null ? (
              <></>
            ) : (
              <MainBar.Navigation>
                <NavigationList>
                  <NavigationListItem
                    onClick={() => navigate("/home")}
                    href="/home"
                  >
                    Dashboard
                  </NavigationListItem>
                  <NavigationDropdownItem label="Templates">
                    <NavigationListItem
                      onClick={() => navigate("/templates")}
                      href="/templates"
                    >
                      Templates Preview
                    </NavigationListItem>
                    {!loggedUserRole.includes(USER_ROLE.ADMIN) &&
                    !loggedUserRole.includes(USER_ROLE.READ_WRITE) ? (
                      ""
                    ) : (
                      <NavigationListItem
                        onClick={() => navigate("/addtemplate")}
                        href="/addtemplate"
                      >
                        Add Template
                      </NavigationListItem>
                    )}
                  </NavigationDropdownItem>
                  <NavigationDropdownItem label="Printer">
                    <NavigationListItem
                      onClick={() => navigate("/printerdetails")}
                      href="/printerdetails"
                    >
                      Printer View
                    </NavigationListItem>
                    <NavigationListItem
                      onClick={() => navigate("/errorcode")}
                      href="/errorcode"
                    >
                      Printer Error Codes
                    </NavigationListItem>
                    {!loggedUserRole.includes(USER_ROLE.ADMIN) &&
                    !loggedUserRole.includes(USER_ROLE.READ_WRITE) ? (
                      ""
                    ) : (
                      <NavigationListItem
                        onClick={() => navigate("/addprinter")}
                        href="/addprinter"
                      >
                        Add Printer
                      </NavigationListItem>
                    )}
                    {!loggedUserRole.includes(USER_ROLE.ADMIN) &&
                    !loggedUserRole.includes(USER_ROLE.READ_WRITE) ? (
                      ""
                    ) : (
                      <NavigationListItem
                        onClick={() => navigate("/addprintermodel")}
                        href="/addprintermodel"
                      >
                        Add Printer Model
                      </NavigationListItem>
                    )}
                    {!loggedUserRole.includes(USER_ROLE.ADMIN) &&
                    !loggedUserRole.includes(USER_ROLE.READ_WRITE) ? (
                      ""
                    ) : (
                      <NavigationListItem
                        onClick={() => navigate("/addlocation")}
                        href="/addlocation"
                      >
                        Add Location
                      </NavigationListItem>
                    )}
                    <NavigationListItem
                      onClick={() => navigate("/printerstatus")}
                      href="/printerstatus"
                    >
                      Printer Status
                    </NavigationListItem>
                  </NavigationDropdownItem>
                </NavigationList>
              </MainBar.Navigation>
            )
          ) : (
            <></>
          )}
        </MainBar>
      </HeaderFlexible>
    </>
  );
};

export default Headerfile;
